import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=04a83665&scoped=true"
import script from "./chat.vue?vue&type=script&setup=true&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=04a83665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a83665",
  null
  
)

export default component.exports